(ns ui.editors.card.fees.sub
  (:require
   [re-frame.core :as rf]
   [ui.editors.card.sub :as common-sub]
   [common.localization :as loc]
   [ui.state.session.sub :as session-sub]

   ;; TODO remove this import later because it uses frontend.session
   [frontend.view.field-templates :as templates]
   [common.schema.registry :as registry]))

(rf/reg-sub
 ::table-config
 :<- [::common-sub/card-config]
 (fn [card-config]
   (:table card-config)))

(rf/reg-sub
 ::entity-peek-config
 :<- [::common-sub/card-config]
 (fn [card-config]
   (:entity-peek card-config)))

(rf/reg-sub
 ::sort-direction
 :<- [::table-config]
 (fn [table-config]
   (some-> table-config
           :sort-model
           first
           :direction)))

(rf/reg-sub
 ::group-by-field
 :<- [::table-config]
 (fn [table-config]
   (:group-by-field table-config)))

;; TODO: modify this if we want to sort by multiple fields
(rf/reg-sub
 ::table-sort-by-field
 :<- [::table-config]
 :<- [::session-sub/tenant-schema]
 (fn [[table-config tenant-schema]]
   (some-> table-config
           :sort-model
           first
           :field)))

(rf/reg-sub
 ::selected-columns
 :<- [::table-config]
 :<- [::session-sub/tenant-schema]
 (fn [[table-config tenant-schema]]
   (->> table-config
        :columns
        (mapv (fn [col-config]
                (let [field (:field col-config)
                      field-schema (registry/get-field-schema tenant-schema field)
                      label (loc/field-name field field-schema)]
                  (assoc col-config
                         :value field
                         :label label)))))))

(rf/reg-sub
 ::table-columns
 :<- [::table-config]
 :<- [::session-sub/tenant-schema]
 (fn [[table-config tenant-schema]]
   (->> table-config
        :columns
        (mapv
         (fn [col-config]
           (let [field (:field col-config)
                 field-schema (registry/get-field-schema tenant-schema field)
                 label (loc/field-name field field-schema)]
             (assoc col-config
                    :label label
                    :value field)))))))
(rf/reg-sub
 ::selected-table-fields
 :<- [::table-columns]
 (fn [table-columns]
   (->> table-columns
        (mapv :field))))

;; FIXME: Discuss with PO and Timo how we want to handle this
;; and if there is a way to create a pure function that can be used like
;; "Get entity fields that tenant user can display in table/card/ui"
(defn entity-visible-field-options
  [{:keys [entity-type tenant-schema]}]
  (let [schema (templates/entity-type-template
                {:entity-type     entity-type
                 :selected-fields []
                 :tenant-schema   tenant-schema
                 :account         nil
                 :role            nil
                 :remove-fields   #{:db/id
                                    :common/system-kws}
                 :overrides       nil})]
    (->> schema
         (remove (fn [[_ field-schema]]
                   (:field/secondary-field? field-schema)))
         (mapv (fn [[field field-schema]]
                 (let [label (loc/field-name field field-schema)]
                   {:value field
                    :label label})))
         (sort-by :label)
         (vec))))

(rf/reg-sub
 ::table-entity-field-options
 :<- [::table-config]
 :<- [::session-sub/tenant-schema]
 (fn [[table-config tenant-schema]]
   (let [entity-type (:entity-type table-config)
         options (entity-visible-field-options
                  {:entity-type entity-type
                   :tenant-schema tenant-schema})]
     options)))

(rf/reg-sub
 ::table-available-column-options
 :<- [::selected-table-fields]
 :<- [::table-entity-field-options]
 (fn [[selected-fields all-field-options]]
   (let [selected-set (set selected-fields)]
     (->> all-field-options
          (filterv (fn [{:keys [value]}]
                     (not (selected-set value))))))))

(rf/reg-sub
 ::table-group-by-field-options
 :<- [::selected-table-fields]
 :<- [::table-entity-field-options]
 :<- [::session-sub/tenant-schema]
 (fn [[selected-fields all-field-options tenant-schema]]
   (let [selected-set (set selected-fields)]
     (->> all-field-options
          (filterv (fn [{:keys [value]}]
                     (let [field value
                           field-schema (registry/get-field-schema tenant-schema field)
                           data-type (:field/data-type field-schema)
                           single-select? (#{:data.type/ref-single :data.type/keyword} data-type)]
                       (and single-select? (selected-set value)))))))))

(rf/reg-sub
 ::entity-peek-visible-fields-strategy
 :<- [::entity-peek-config]
 (fn [entity-peek-config]
   (:visible-fields-strategy entity-peek-config)))

(rf/reg-sub
 ::entity-peek-visible-fields
 :<- [::entity-peek-config]
 :<- [::session-sub/tenant-schema]
 (fn [[entity-peek-config tenant-schema]]
   (->> entity-peek-config
        :visible-fields
        (mapv (fn [{:keys [field] :as field-config}]
                (let [field-schema (registry/get-field-schema tenant-schema field)
                      label (loc/field-name field field-schema)]
                  (assoc field-config
                         :label label
                         :value field)))))))

(rf/reg-sub
 ::entity-peek-available-visible-field-options
 :<- [::entity-peek-visible-fields]
 :<- [::entity-peek-config]
 :<- [::session-sub/tenant-schema]
 (fn [[entity-peek-visible-fields entity-peek-config tenant-schema]]
   (let [selected-fields-set (->> entity-peek-visible-fields
                                  (mapv :value)
                                  set)
         entity-type (:entity-type entity-peek-config)
         all-options (entity-visible-field-options
                      {:entity-type entity-type
                       :tenant-schema tenant-schema})]
     (->> all-options
          (filterv (fn [{:keys [value]}]
                     (not (selected-fields-set value))))))))
